import { z } from "zod";

export const presignedUrlDto = z.object({
  fileName: z.string().min(1),
});

export type PresignedUrlReq = z.infer<typeof presignedUrlDto>;
